import styled from '@emotion/styled'

export type Roles = {
  isChecked: boolean
  name: string
}

export type RolesProps = {
  filter: string[]
  onChangeRoleFilter: (x: string) => void
  roles: string[]
}

const Wrapper = styled.div`
  padding: 24px 24px 12px;
  border: Solid 1px var(--White95);
  border-radius: 4px;
  min-width: 150px;
  max-width: 200px;
  background: var(--White);
  box-shadow: 0px 0px 4px 2px var(--White80);
`

const RolesWrapper = styled.div`
  margin: 0 0 12px;
`

const StyledLabel = styled.label`
  vertical-align: center;
  display: table-cell;
  cursor: pointer;
`

const StyledCheckboxInput = styled.input`
  margin: 0 8px 0 0;
  vertical-align: middle;
`

export const RolesSelector = ({ filter, onChangeRoleFilter, roles }: RolesProps) => (
  <Wrapper>
    {roles.map(role => (
      <RolesWrapper key={role}>
        <StyledLabel>
          <StyledCheckboxInput
            checked={filter.includes(role)}
            type="checkbox"
            onChange={() => onChangeRoleFilter(role)}
          />
          {role}
        </StyledLabel>
      </RolesWrapper>
    ))}
  </Wrapper>
)
